import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getUserInfo, getUserInfoSuccess } from '../../state/user/User.actions';
import { withRouter } from '../../utils/NavigationWrapper';
import { withAppInsights } from '../../utils/AppInsights';
import Page from './Page';

class PageContainer extends Component {
  componentDidMount() {
    this.props._getUserInfo();
  }

  render() {
    const { user } = this.props;

    if (!user) {
      return null;
    }

    return <Page {...this.props} />;
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  _getUserInfo: () => {
    return getUserInfo()
      .then((res) => dispatch(getUserInfoSuccess(res.body)))
      .catch((err) => console.log(err));
  },
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withAppInsights(PageContainer))
);
